var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid/16*16/informative/warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.645 2.77728C7.23544 1.74091 8.76391 1.74091 9.35435 2.77728L14.4691 11.7549C15.0429 12.7622 14.296 14 13.1144 14H2.88493C1.70331 14 0.956411 12.7622 1.53025 11.7549L6.645 2.77728ZM8.6663 11.3333C8.6663 11.7015 8.36782 12 7.99963 12C7.63144 12 7.33297 11.7015 7.33297 11.3333C7.33297 10.9651 7.63144 10.6667 7.99963 10.6667C8.36782 10.6667 8.6663 10.9651 8.6663 11.3333ZM8.49963 6C8.49963 5.72386 8.27578 5.5 7.99963 5.5C7.72349 5.5 7.49963 5.72386 7.49963 6V9.33333C7.49963 9.60948 7.72349 9.83333 7.99963 9.83333C8.27578 9.83333 8.49963 9.60948 8.49963 9.33333V6Z",
    fill: "#CF1322"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.bdd4b7320b8c0fd86dbb123e178045ff.svg";